<div [class.main_container]="isLoginPage === true">
  <div *ngIf="loading" class="slider">
    <div class="line"></div>
    <div class="subline inc"></div>
    <div class="subline dec"></div>
  </div>
  <router-outlet></router-outlet>
</div>
